import { type ReactNode, useEffect } from "react";
import { UnlockSync } from "#/lib/useUnlockSync";
import { cn } from "#/lib/utils";
import { ASSETS } from "../../lib/assets";
import { CartUIProvider, useCartUI } from "../../lib/cart-ui";
import { Toaster } from "../ui/sonner";
import { CartDrawer } from "./CartDrawer";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { MobileTabBar } from "./MobileTabBar";
import { SearchDialog } from "./SearchDialog";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <CartUIProvider>
      <LayoutInner>{children}</LayoutInner>
    </CartUIProvider>
  );
}

function LayoutInner({ children }: { children: ReactNode }) {
  const { openSearch, openCart, closeCart, closeSearch, cartOpen, searchOpen } =
    useCartUI();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        openSearch();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openSearch]);

  return (
    <div
      className={cn(
        "flex min-h-screen flex-col bg-background text-foreground",
        "pb-[calc(5.5rem+env(safe-area-inset-bottom))] lg:pb-0",
      )}
    >
      <Header
        onOpenCart={openCart}
        onOpenSearch={openSearch}
        logoSrc={ASSETS.logo}
      />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileTabBar onOpenCart={openCart} homeLogoSrc={ASSETS.logo} />
      <CartDrawer open={cartOpen} onClose={closeCart} />
      <SearchDialog open={searchOpen} onClose={closeSearch} />
      <Toaster />
      <UnlockSync />
    </div>
  );
}
